<template>
  <div class="addMain wraper">
    <template>
      <el-backtop target=".wraper"></el-backtop>
    </template>
    <div v-if="$route.meta.routeList.length>1" class="returnBtn" @click="goBack()">
      <i class="el-icon-back"></i>
    </div>
    <el-breadcrumb class="crumbs" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item,index)  in routeList" :key="index"
        :to="{ name: item.name,query:{id:item.query.id,flag:item.query.flag,name:item.query.name} }">
        {{item.name}}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never">
      <div class="cardTop">
        <h1 v-if="flag != 'edit'">创建产品</h1>
        <h1 v-if="flag == 'edit'">更新产品</h1>
      </div>
      <div class="cardBottom">
        <div class="addIntroduce">
          <h3 v-if="flag != 'edit'">创建产品的文字介绍。</h3>
          <h3 v-if="flag == 'edit'">产品的文字介绍。</h3>
        </div>
        <el-form ref="addForm" :model="addForm" :rules="rules">
          <el-form-item label="产品名称" prop="name"><br />
            <el-input v-model="addForm.name" placeholder="请输入" maxlength="255"></el-input>
          </el-form-item>
          <el-form-item v-if="flag != 'edit'" label="通信类型" prop="commuType"><br />
            <div class="subheading">请选择通信类型</div>
            <el-select v-model="addForm.commuType" filterable placeholder="未选择" @change="commuTypeChange">
              <el-option v-for="item in commuTypeList" :key="item.id" :label="item.content" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="flag != 'edit'" label="厂家平台" prop="accessPlatform"><br />
            <div>
              <el-select v-model="addForm.accessPlatform" filterable placeholder="未选择">
                <el-option v-for="item in accessPlatformList" :key="item.value" :label="item.content"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-form-item>

          <el-form-item v-if="flag != 'edit'" label="参数" prop="parameter"><br />
            <div class="subheading">对接平台所需要的参数key </div>
            <div style="display: inline-block;width:100%;position: relative;" v-for="(item,index) in addForm.parameter"
              :key="index">
              <img v-if="flag != 'detail' && index != 0 && item.para!='mqttPassword' & item.para!='mqttUsername'"
                style="width: 15px;position: absolute;left: -22px;top: 21px;cursor: pointer;"
                @click="delPara(item, index)" src="../../assets/images/error.png" alt="" />
              <el-input v-model="item.para" :disabled="item.para=='mqttPassword'|| item.para=='mqttUsername'"
                placeholder="请输入"></el-input>
              <el-button v-if="addForm.parameter.length-1==index" class="briefBtn" @click.native.prevent="addKey">添加参数
              </el-button>
            </div>

          </el-form-item>

          <el-form-item v-if="flag != 'edit'" label="网关协议" prop="moduleProtocolId"><br />
            <div>
              <el-select v-model="addForm.moduleProtocolId" filterable placeholder="未选择">
                <el-option v-for="item in moduleProtocolList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <el-button class="briefBtn" @click="addProtocol">创建协议</el-button>
            </div>
          </el-form-item>

          <el-form-item v-if="flag != 'edit'" label="设备协议" prop="deviceProtocolId"><br />
            <div>
              <el-select v-model="addForm.deviceProtocolId" filterable placeholder="未选择">
                <el-option v-for="item in deviceProtocolList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <el-button class="briefBtn" @click="addProtocol">创建协议</el-button>
            </div>
          </el-form-item>
          <el-form-item label="备注" prop="remarks"><br />
            <div class="subheading">根据需要，输入网关备注信息。</div>
            <el-input type="textarea" :rows="3" v-model="addForm.remarks" placeholder="请输入" maxlength="255"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="text" @click="$router.history.go(-1)">取消</el-button>
            <el-button v-if="flag != 'edit'" type="primary" @click="onSubmit('addForm')">创建产品</el-button>
            <el-button v-if="flag == 'edit'" type="primary" @click="editOnSubmit('addForm')">更新产品</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>
<script>
  import API from "../../api/api";
  export default {
    data() {
      return {
        routeList: this.$route.meta.routeList,
        flag: this.$route.query.flag,
        rules: {
          name: [{
            required: true,
            message: "请输入产品名称",
            trigger: "blur"
          }],
          accessPlatform: [{
            required: true,
            message: "请选择厂家平台",
            trigger: "change"
          }]
        },
        addForm: {
          name: null,
          commuType: 1,
          accessPlatform: "",
          moduleProtocolId: "",
          deviceProtocolId: '',
          remark: null,
          parameter: [{}], //参数
        },
        accessPlatformList: [],
        commuTypeList: [{
            id: 1,
            content: 'TCP'
          },
          {
            id: 2,
            content: 'UDP'
          },
          {
            id: 3,
            content: 'MQTT'
          },
          {
            id: 4,
            content: 'HTTP'
          }, {
            id: 5,
            content: 'COAP'
          },
        ],
        moduleProtocolList: [],
        deviceProtocolList: [],
      };
    },
    created() {},
    methods: {

      getAccessPlatformList() {

        API.getDictionaryListByCode({
          typeCode: "access_platform"
        }).then(res => {
          if (res.code === 1) {
            this.accessPlatformList = res.data.dictionaryList
          }
        })

      },


      //当页面为编辑状态flag==edit时要获取到当前编辑的信息
      getMage() {
        //获取网关协议
        this.getProtocolList();
        if (this.flag == "edit") {
          let id = this.$route.query.id;
          API.platformProductView(id).then(res => {
            if (res.code == 1) {
              this.addForm = res.data;
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          this.getAccessPlatformList()
          return false;
        }
      },
      //新增参数
      addKey() {
        this.addForm.parameter.push({})
      },
      delPara(item, index) {
        //   if ( this.addForm.parameter.length <= 1) {
        //   this.$message({
        //     type: "warning",
        //     message: "最少添加一个参数"
        //   });
        //   return false;
        // }
        this.addForm.parameter.splice(index, 1);
      },
      //根据通信类型获取网关协议和设备协议
      commuTypeChange(val) {
        this.addForm.moduleProtocolId = ""; //通信类型改变，网关协议清空
        this.addForm.deviceProtocolId = ""; //通信类型改变，设备协议清空
        this.getProtocolList();
        if (val == 3) {
          this.addForm.parameter.unshift({
            para: 'mqttPassword'
          })
          this.addForm.parameter.unshift({
            para: 'mqttUsername'
          })
        } else {
          this.addForm.parameter = []
          this.addForm.parameter.push({})
        }
      },
      //查询网关协议下拉数据
      getProtocolList() {
        let param = {
          commuType: this.addForm.commuType
        };
        API.platformMduModuleModuleProtocolList(param).then(res => {
          if (res.code == 1) {
            this.moduleProtocolList = res.data.protocolList;
          }
        });
        API.platformDevDeviceProtocol(param).then(res => {
          if (res.code == 1) {
            this.deviceProtocolList = res.data;
          }
        });
      },
      //创建网关
      onSubmit(formName) {
        let _this = this;
        let _API = API;
        this.$refs[formName].validate(valid => {
          if (valid) {

            _this.addForm.paramKeys = _this.addForm.parameter.map(x => x.para).join(",")
            if (_this.addForm.paramKeys.endsWith(",")) {
              _this.addForm.paramKeys = _this.addForm.paramKeys.substring(0, _this.addForm.paramKeys.length - 1)
            }
            _this.addForm.parameter = ''
            _API.platformProductAdd(_this.addForm).then(res => {
              if (res.code == 1) {
                _this.$message({
                  message: "创建产品成功",
                  type: "success"
                });
                _this.$router.push({
                  path: "/product/productManagement"
                });
              } else {
                _this.$message({
                  message: res.msg,
                  type: "error"
                });
              }
            });
          } else {
            _this.$message({
              message: "请填写完所有必填项",
              type: "error"
            });
            return false;
          }
        });
      },
      //创建协议
      addProtocol() {
        this.$router.push({
          path: "/device/protocolAdd",
          query: {
            data: JSON.stringify(this.addForm)
          }
        });
      },
      moduleProtocolDetailsBtn(id) {
        const ids = id;
        this.$router.push({
          path: "/device/moduleProtocolDetails",
          query: {
            id: ids
          }
        });
      },
      //更新产品
      editOnSubmit(formName) {
        let _this = this;
        let _API = API;
        this.$refs[formName].validate(valid => {
          if (valid) {
            _API.platformProductEdit(this.$route.query.id, _this.addForm)
              .then(res => {
                if (res.code == 1) {
                  _this.$message({
                    message: "更新产品成功",
                    type: "success"
                  });
                  _this.$router.push({
                    path: "/product/productManagement"
                  });
                } else {
                  _this.$message({
                    message: res.msg,
                    type: "error"
                  });
                }
              });
          } else {
            _this.$message({
              message: "请填写完所有必填项",
              type: "error"
            });
            return false;
          }
        });
      }
    },
    mounted() {
      this.getMage();
      if (this.$route.params.data) {
        this.addForm = JSON.parse(this.$route.params.data)
      }
    }
  };

</script>



// WEBPACK FOOTER //
// src/views/platform/productAdd.vue